export enum HomeConstants {
  SET_PCR_LIST = 'home/SET_PCR_LIST',
  HOME_NOT_IMPLEMENTED = 'home/HOME_NOT_IMPLEMENTED',
  ON_SELECT_PCR = 'home/ON_SELECT_PCR',
  ON_LOAD_PCR = 'home/ON_LOAD_PCR',
  FILTER_INCOMPLETE = 'home/FILTER_INCOMPLETE',
  SET_INCOMPLETE_FILTER = 'home/SET_INCOMPLETE_FILTER',
  FILTER_COMPLETE = 'home/FILTER_COMPLETE',
  SET_COMPLETE_FILTER = 'home/SET_COMPLETE_FILTER',
  FILTER_NEEDS_REVIEW = 'home/FILTER_NEEDS_REVIEW',
  SET_NEEDS_REVIEW_FILTER = 'home/SET_NEEDS_REVIEW_FILTER',
  CLEAR_FILTERS = 'home/CLEAR_FILTERS',
  SET_NEW_PCR = 'home/SET_NEW_PCR',
  SET_PCRID = 'home/SET_PCRID',
  SET_PCR = 'home/SET_PCR',
  SET_PRID = 'home/SET_PRID',
  SET_FILTERED_PCR_LIST = 'home/SET_FILTERED_PCR_LIST',
  APPLY_FILTERS = 'home/APPLY_FILTERS',
  UPGRADE_PCR = 'home/UPGRADE_PCR',
  SET_UPGRADE_STATUS = 'home/SET_UPGRADE_STATUS',
  RESET_VALIDATIONS = 'home/RESET_VALIDATIONS',
  RESET_PCR = 'home/RESET_PCR',
  SET_ADDRESS_TYPE = 'home/SET_ADDRESS_TYPE',
  GET_ALL_PCR_DOCS = 'home/GET_ALL_PCR_DOCS',
  DELETE_PCR = 'home/DELETE_PCR',
  SET_IS_PCR_OPENING = 'home/SET_IS_PCR_OPENING',
  SET_IS_PCR_CLOSING = 'home/SET_IS_PCR_CLOSING',
  SET_IS_PCR_ERROR = 'home/SET_IS_PCR_ERROR',
  SET_IS_CHART_LOCKED_IN = 'home/SET_IS_CHART_LOCKED_IN',
  CLEAR_SELECTED_PCR = 'home/CLEAR_SELECTED_PCR',
  RESET_HOME_STATE = 'home/RESET_HOME_STATE',
  CHECK_FOR_FAILED_AUTO_UPLOADS = 'home/CHECK_FOR_FAILED_AUTO_UPLOADS',
  INITIATE_AUTO_UPLOAD = 'home/INITIATE_AUTO_UPLOAD',
}
